import { render } from "./SubscriptionMonthlyAmounts.vue?vue&type=template&id=c00110e8"
import script from "./SubscriptionMonthlyAmounts.vue?vue&type=script&lang=js"
export * from "./SubscriptionMonthlyAmounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__